// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2227":"b9b2aeba","4658":"944a549c","5153":"424caa0d","5652":"eb2324d6","6245":"f3566de3","7771":"f55676df","9782":"438a0974"}[chunkId] + ".chunk.js";
};